import React from 'react'

function Giftcards() {
  return (
    <div>Gift-Cards</div>
  )
}

export default Giftcards